import { isAppStateReady } from '$appStore'
import { logger } from '$utils'
import { defer } from 'react-router-dom'
import useComplianceStore from '../store'

export default async function loader() {
  logger.debug(
    '[loader] About to await AppState being ready in LeaveTypes loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in LeaveTypes loader')

  const getLeaveTypes = useComplianceStore.getState().getLeaveTypes()

  return defer({
    data: Promise.all([getLeaveTypes])
      .then(() => true)
      .catch((error) => {
        logger.error('Leave Types Promise.all error', error)
        return false
      }),
  })
}
